export default {
  chat: {
    minWidth: 1,
    minHeight: 1,
    maxWidth: 455,
    maxHeight: 730,
  }
}
